import { useDestroyRestDays } from 'modules/shift_management/hooks/useDestroyRestDays'
import { useDestroyShifts } from 'modules/shift_management/hooks/useDestroyShifts'
import getTransactionType from 'modules/shift_management/lib/getTransactionType'
import shiftManagementCounts from 'modules/shift_management/lib/shiftManagementCounts'
import type { RestDay, Shift } from 'modules/shift_management/lib/types'

import { useDestroyShiftsAndRestDays } from './useDestroyShiftsAndRestDays'

interface Props {
  shifts: Shift[]
  restDays: RestDay[]
  destroyBackupShifts: boolean
  destroyAutomaticOnly?: boolean
}

const useBulkDestroy = ({
  shifts,
  restDays,
  destroyBackupShifts,
  destroyAutomaticOnly = false,
}: Props) => {
  const { shiftsCount, restDaysCount, employeeCount } = shiftManagementCounts(shifts, restDays)
  const transactionType = getTransactionType(shiftsCount, restDaysCount)

  const { onDestroy: onDestroyShifts, submitting: submittingShifts } = useDestroyShifts({
    shifts,
    employeeCount,
    destroyBackupShifts,
    destroyAutomaticOnly,
  })
  const { onDestroy: onDestroyRestDays, submitting: submittingRestDays } = useDestroyRestDays(
    restDays,
    employeeCount
  )

  const { performAction, submitting } = useDestroyShiftsAndRestDays({
    shifts,
    restDays,
    destroyBackupShifts,
    destroyAutomaticOnly,
  })

  switch (transactionType) {
    case 'shifts':
      return { onDestroy: onDestroyShifts, submitting: submittingShifts }
    case 'rest-days':
      return { onDestroy: onDestroyRestDays, submitting: submittingRestDays }
    case 'both':
      return { onDestroy: performAction, submitting }
  }
}

export default useBulkDestroy
